<div class="row p-2 ">
    <div class="col-sm-12 w-100">
        <div class="d-flex flex-column justify-content-between  row w-100 m-0">


        
              <!-- <img class="px-3"
              style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
              src="https://appointele.com/assets/logo2020w.png" />-->

              <img class="px-3"
                style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
              src="./assets/logo2020w.png" />

            <div class="w-100 text-center">
                <h1 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>WELCOME </h1>
            </div>

            <div class="border  bg-white "></div>
            <div class="w-100 text-center">
                <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';"> </h4>
            </div>



















            <div class="jumbotron p-0" style="background: black;">
                <div class="container ">
                    <div class="row">
                        <div class="col-md-12 p-0 ">

                            <form [formGroup]="searchForm"  class="text-center border border-light p-3">

                                <p class="h4 mb-4 text-white p-2" style="font-family:'DINPro';" translate>Please complete the following questionaire</p>


                        
                                <div class="float-right w-100">
                                    <!--  <h3 class="float-left align-center py-3 text-danger"></h3> <div class="float-left py-4 text-danger">All fields are mandatory</div>-->
                                </div>
                                <br>

                                <div class="text-white" *ngIf="loading" ><img class="pl-2 h-50 w-50 text-center"
                                    src="https://media.giphy.com/media/3FbIritvFtzHx1ALoS/giphy.gif" /> <br> translate>Loading...</div>
                                <!-- {{registerForm.value | json}}-->
                                <div class="form-group py-2">
                                    <label translate class="text-left font-weight-bold text-white p-2 rounded w-100" style="font-family:'DINPro';">Full
                                        Name</label>
                                    <input type="text" formControlName="fullName" class="form-control"
                                        [class.is-invalid]="formErrors.fullName" 
                                        (blur)="logValidationErrors(searchForm)" />

                                    <div [class.d-none]="!formErrors.fullName">
                                        <small translate>{{formErrors.fullName}}</small></div>
                                </div>



                                <div class="form-group py-2" hidden>
                                    <label translate class="text-left font-weight-bold text-white p-2 rounded w-100" style="font-family:'DINPro';">Email</label>
                                    <input type="text" formControlName="email" class="form-control"
                                        [class.is-invalid]="formErrors.email" 
                                        (blur)="logValidationErrors(searchForm)" />

                                    <div [class.d-none]="!formErrors.email">
                                        <small translate>{{formErrors.email}}</small></div>

                                </div>






                                <div class="form-group py-2"  >
                                    <label translate class="text-left font-weight-bold text-white p-2 rounded w-100" style="font-family:'DINPro';">Phone
                                        Number</label>
                                    <input type="text" formControlName="phoneNumber" class="form-control"
                                        [class.is-invalid]="formErrors.phoneNumber" 
                                        (blur)="logValidationErrors(searchForm)" />

                                    <div [class.d-none]="!formErrors.phoneNumber">
                                        <small translate>{{formErrors.phoneNumber}}</small></div>
                                </div>


                                <div class="form-group py-2" hidden >
                                    <label translate class="text-left font-weight-bold text-white p-2 rounded w-100">Please select location for appointment?</label>
                                    <select class="form-control select2tag select2-hidden-accessible"
                                        formControlName="branch" id="branch" name="branch"
                                        style="width: 100%;" tabindex="-1" aria-hidden="true" 
                                   >
                                        <option value='0'>SELECT</option>
                                        <option *ngFor='let branch of branchs' value={{branch}}>{{branch}}</option>
                                    
                                    </select>
                                    <div [class.d-none]="!formErrors.branch">
                                        <small translate>{{formErrors.branch}}</small></div>
                                </div>






                                <div class="form-group m-2 text-center d-flex flex-column ">
                             <!--      <div *ngIf="loading">
                                        <h3>Please wait...</h3>
                                    </div>-->
                                   

                                         
<!--Submit Button with Covid Questionarie
                                    <div class="text-center"><button [disabled]="loading"
                                            [disabled]='!searchForm.valid || !searchForm.valid'
                                            data-toggle="modal" data-target="#covidModal" class="btn  text-dark "
                                            style="align-content: center;  background: white;"><i
                                                class="fa fa-check"></i>
                                            Next</button>
                                    </div>-->
                                    <div class="text-center"><button 
                                        [disabled]='!searchForm.valid || !searchForm.valid || loading' translate
                                        class="btn  text-dark " (click)="onSubmit()" style="align-content: center;  background: white;"><i
                                            class="fa fa-check"></i>
                                        Confirm</button>
                                </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>










        </div>
    </div>
</div>


<!---------- Covid Modal ------------------------------------------------------------------------------------------------------------>
<!--<div class="modal fade " id="covidModal" tabindex="-1" role="dialog" style="background: black;"
    aria-labelledby="covidModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="covidModalLabel">
                    <strong></strong></h5>
              
            </div>
            <div class="modal-body " style="background: black;">
                <div class="row p-5 ">
                    <div class="col-sm-12 w-100">
                        <div class="d-flex flex-column justify-content-between  row w-100 m-0">


                  
                          

                           <img class="px-3"
                            style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                            src="https://test.appointele.com/assets/logo2020w.png" />

                            <div class="w-100 text-center">
                                <h3 class="bg-black text-white pt-4" style="font-family:'DINPro';">COVID-19 SELF
                                    ASSESSMENT DECLARATION </h3>
                            </div>

                            <div class="border  bg-white "></div>
                            <div class="w-100 text-center">
                                <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';">I do not have any
                                    COVID-19 related symptoms and not have been in contact with anyone with COVID-19
                                    related symptoms. </h4>
                            </div>

                    



                            <div class="pt-5" style="display: block; margin-right: auto; margin-left: auto; ">
                                <h1 class="text-dark  mt-5 p-3 px-5 bg-white text-center"
                                    style="font-family:'DINPro'; font-weight: bold; "><a class="text-dark "
                                    data-dismiss="modal"   (click)="onSubmit('PASS')">I AGREE</a></h1>
                            </div>
                            <div class="pb-5 " style="display: block; margin-right: auto; margin-left: auto; ">
                                <h1 class="text-dark  mb-5 p-3 bg-white text-center"
                                    style="font-family:'DINPro'; font-weight: bold; "><a class="text-dark "
                                    data-dismiss="modal" (click)="onSubmit('FAIL')">I DO NOT AGREE</a></h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



        </div>
    </div>
</div>-->


<!------------------------------------------------------------------------------------------------------------------------------------------
                        No Appointment Found Modal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
                    <button id="openNoAppointmentModalButton" [hidden]="true" data-toggle="modal" data-target="#NoAppointmentModal">Open Modal</button>
                    <!-- Modal -->
                    <div id="NoAppointmentModal" class="modal fade" role="dialog">
                        <div class="modal-dialog">
                    
                            <!-- Modal content-->
                            <div class="modal-content">
                                <div class="modal-header">
                    
                               <!-- <h4 class="modal-title text-success">SUCCESS</h4>
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>-->
                                </div>
                                <div class="modal-body " style="background: black;">
                                    <div class="row p-5 ">
                                        <div class="col-sm-12 w-100">
                                            <div class="d-flex flex-column justify-content-between  row w-100 m-0">
                    
                    
                                               <!-- <img class="px-3"
                                                    style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                                    src="https://appointele.com/assets/logo2020w.png" />-->

                                                    <img class="px-3"
                                                    style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                                    src="./assets/logo2020w.png" />
                    
                                                <div class="w-100 text-center">
                                                    <h3 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>THANK YOU </h3>
                                                </div>
                    
                                                <div class="border  bg-white "></div>
                                                <div class="w-100 text-center">
                                                    <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>Unfortunately, we were not able to find any appointments</h4>
                                                </div>
                    
                                                <div class="w-100 text-center">
                                                    <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>Please click on proceed </h4>
                                                </div>
                    
                    
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-default text-center" data-dismiss="modal" (click)="proceedtoquestionaire()"  translate>Proceed</button>
                                </div>
                            </div>
                    
                        </div>
                    </div>

      
                    <!------------------------------------------------------------------------------------------------------------------------------------------
                        COVID Positive Modal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
                    <button id="opencovidPositiveModalButton" [hidden]="true" data-toggle="modal" data-target="#CovidPositiveModal">Open Modal</button>
                    <!-- Modal -->
                    <div id="CovidPositivetModal" class="modal fade" role="dialog">
                        <div class="modal-dialog">
                    
                            <!-- Modal content-->
                            <div class="modal-content">
                                <div class="modal-header">
                    
                               <!-- <h4 class="modal-title text-success">SUCCESS</h4>
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>-->
                                </div>
                                <div class="modal-body " style="background: black;">
                                    <div class="row p-5 ">
                                        <div class="col-sm-12 w-100">
                                            <div class="d-flex flex-column justify-content-between  row w-100 m-0">
                    
                    
                                               <!-- <img class="px-3"
                                                    style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                                    src="https://appointele.com/assets/logo2020w.png" />-->
                                                    <img class="px-3"
                                                    style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                                    src="./assets/logo2020w.png" />
                    
                                                <div class="w-100 text-center">
                                                    <h3 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>THANK YOU </h3>
                                                </div>
                    
                                                <div class="border  bg-white "></div>
                                                <div class="w-100 text-center">
                                                    <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>Your information has been forwarded.</h4>
                                                </div>
                    
                                                <div class="w-100 text-center">
                                                    <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>Please confirm with reception that you have been signed in. </h4>
                                                </div>
                    
                    
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-default text-center" routerLink='/appointment-questionaire' data-dismiss="modal" translate>Proceed</button>
                                </div>
                            </div>
                    
                        </div>
                    </div>


<!------------------------------------------------------------------------------------------------------------------------------------------
                        Success Modal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
<button id="openSuccessFoundAppointmentModalButton" [hidden]="true" data-toggle="modal" data-target="#SuccessFoundAppointmentModal">Open Modal</button>
<!-- Modal -->
<div id="SuccessFoundAppointmentModal" class="modal fade" role="dialog">
    <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">

           <!-- <h4 class="modal-title text-success">SUCCESS</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>-->
            </div>
            <div class="modal-body " style="background: black;">
                <div class="row p-5 ">
                    <div class="col-sm-12 w-100">
                        <div class="d-flex flex-column justify-content-between  row w-100 m-0">


                            <!--<img class="px-3"
                                style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                src="https://appointele.com/assets/logo2020w.png" />-->
                                <img class="px-3"
                                style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                src="./assets/logo2020w.png" />

                            <div class="w-100 text-center">
                                <h3 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>THANK YOU </h3>
                            </div>

                            <div class="border  bg-white "></div>
                            <div class="w-100 text-center">
                                <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>Your information has been forwarded.</h4>
                            </div>

                            <div class="w-100 text-center">
                                <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>Please confirm with reception that you have been signed in. </h4>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default text-center" routerLink='/welcome' data-dismiss="modal" translate>Close</button>
            </div>
        </div>

    </div>
</div>


<!------------------------------------------------------------------------------------------------------------------------------------------
                       Error Modal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
<button id="openErrorModalButton" [hidden]="true" data-toggle="modal" data-target="#ErrorModal">Open Modal</button>
<!-- Modal -->
<div id="ErrorModal" class="modal fade" role="dialog">
    <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">

                <h4 class="modal-title text-danger" translate>ERROR</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body text-danger">
                <p>{{error}}</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" routerLink='/assets' data-dismiss="modal" translate>Close</button>
            </div>
        </div>

    </div>


    <!------------------------------------------------------------------------------------------------------------------------------------------
                        Please Wait Modal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
<button id="openWaitModalButton" [hidden]="true" data-toggle="modal" data-target="#WaitModal">Open Modal</button>
<!-- Modal -->
<div id="WaitModal" class="modal fade" role="dialog">
    <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">

           <!-- <h4 class="modal-title text-success">SUCCESS</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>-->
            </div>
            <div class="modal-body " style="background: black;">
                <div class="row p-5 ">
                    <div class="col-sm-12 w-100">
                        <div class="d-flex flex-column justify-content-between  row w-100 m-0">


                            <!--<img class="px-3"
                                style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                src="https://appointele.com/assets/logo2020w.png" />-->

                                <img class="px-3"
                                style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                src="./assets/logo2020w.png" />

                            <div class="w-100 text-center">
                                <h3 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>THANK YOU </h3>
                            </div>

                            <div class="border  bg-white "></div>
                            <div class="w-100 text-center">
                                <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>Please wait while we process your request</h4>
                            </div>

                        


                        </div>
                    </div>
                </div>
            </div>
          <!--  <div class="modal-footer">
                <button type="button" class="btn btn-default text-center" routerLink='/welcome' data-dismiss="modal">Close</button>
            </div>-->
        </div>

    </div>
</div>